import type { Clinic } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { ClinicsFormValues } from './form'
import type { ClinicsVariables } from './variables'

// 1. Tupla QueryDefinition
export type ClinicsQueryDefinition = [
  QueryDefinition<'clinics', 'query', void, Array<Clinic>>,
]

// 2. Endpoint paths
export const CLINIC_ENDPOINTS = {
  list: ['api', 'clinics'] as [string, string],
  delete: ['api', 'clinics'] as [string, string],
  create: ['api', 'clinics'] as [string, string],
  update: (id: string): [string, string] => ['api', `clinics/${id}`],
  detail: (id: string): [string, string] => ['api', `clinics/${id}`],
}

// 3. Query keys
export const CLINIC_KEYS = {
  all: ['clinics'],
  list: () => CLINIC_KEYS.all.join('/'),
  listActive: () => [...CLINIC_KEYS.all, 'active'].join('/'),
  detail: (id: string) => [...CLINIC_KEYS.all, id].join('/'),
  assignments: (from: string, to: string) =>
    [...CLINIC_KEYS.all, 'assignments', from, to].join('/'),
}

// 4. Costante queries
export const clinicsQueries: NonNullable<
  PageProps<
    ClinicsFormValues,
    ClinicsQueryDefinition,
    ClinicsVariables
  >['queries']
> = [
  {
    key: 'clinics',
    type: 'query',
    queryConfig: () => ({
      queryKey: [CLINIC_KEYS.list()],
      endpoint: CLINIC_ENDPOINTS.list,
      enabled: true,
    }),
  },
]
